var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E9E9ED",
    d: "M2 5h20v14H2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.333 12.002c0 1.804-1.492 3.266-3.333 3.266-1.84 0-3.333-1.462-3.333-3.266 0-1.046 2.238-1.484 4.122-1.32.2-.052.415-.08.64-.08 1.052 0 1.904.627 1.904 1.4z",
    fill: "#232C80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.524 11.534s.852-.933 1.905-.933c1.052 0 1.904.627 1.904 1.4 0-1.804-1.492-3.267-3.333-3.267-1.33 0-2.479.764-3.013 1.869-.32.931-.32 1.204-.32 1.398.476.467 1.005.467 1.428.467.423 0 .803-.18 1.065-.467l.364-.467z",
    fill: "#F93939"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.286 9.667h1.904l-1.904-1.866h-.953l.953 1.866zm-8.572 0H5.81l1.904-1.866h.953l-.953 1.866zm8.572 4.667h1.904l-1.904 1.867h-.953l.953-1.867zm-8.572 0H5.81l1.904 1.867h.953l-.953-1.867z",
    fill: "#151515"
  })));
}
export default SvgKr;